import { ModelFavoriteUserFavoritesCompositeKeyConditionInput } from '@/API';
import {
  GetFavoriteQueryVariables,
  GetFavoriteQuery,
  FavoriteType,
  getFavoriteList,
} from '@/appsync/graphql/favorite';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';
import { LoginInfo, ID, TenantLandscape } from '@/types/type';

interface _IFavorite {
  id: ID;
  sort: number;
}

const structureFavorite = (query: GetFavoriteQuery): ID[] => {
  if (query.listFavorites && query.listFavorites.items) {
    return query.listFavorites.items
      .map(
        (item: FavoriteType | null): _IFavorite =>
          item ? { id: item.menuId, sort: item.sort } : { id: '', sort: -1 }
      )
      .sort((item1: _IFavorite, item2: _IFavorite) => item1.sort - item2.sort)
      .filter((item: _IFavorite) => item.id.length)
      .map((item: _IFavorite) => item.id);
  }
  return [];
};

export const fetchFavoriteMenuIdList = async (
  loginInfo: LoginInfo
): Promise<ID[]> => {
  const tenantLandscape: TenantLandscape = {
    tenant: loginInfo.tenant,
    landscape: loginInfo.landscape,
  };
  const favoriteConditionInput: ModelFavoriteUserFavoritesCompositeKeyConditionInput = {
    eq: tenantLandscape,
  };
  const variables: GetFavoriteQueryVariables = {
    loginName: loginInfo.loginName,
    tenantLandscape: favoriteConditionInput,
  };
  const result = await graphqlQuery<
    GetFavoriteQuery,
    GetFavoriteQueryVariables
  >(getFavoriteList, variables);
  if (result) {
    return structureFavorite(result);
  }
  return [];
};
